import { Environments } from '../../constants/environments'
import { FeatureFlagName, featureFlags } from './featureFlags'

export default class FeatureFlagManager {
  public static get<T>(flagName: FeatureFlagName): T {
    return featureFlags[flagName][process.env.REACT_APP_ENV as Environments] as T
  }
}
